export const themeMap: Record<string, () => Promise<any>> = {
  adrenalin: () => import("./adrenalin.css"),
  demohrms: () => import("./demohrms.css"),
  greytip: () => import("./greytip.css"),
  timelabs: () => import("./timelabs.css"),
};
